// MS-7 — Final CTA band. Same WhatsApp target/env as the hero CTA.
// MS-L4B — the raw click now opens the WhatsApp Disclosure dialog via the
// `onOpen` callback provided by the parent Landing. On `Continua` the parent
// dialog opens the SAME REACT_APP_MASTRO_WHATSAPP_URL synchronously.
import { MessageCircle } from "lucide-react";

export const FinalCta = ({ onOpen }) => (
  <div
    data-testid="landing-final-cta"
    className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-16"
  >
    <div className="max-w-xl">
      <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
        Provalo mentre lavori.
      </h2>
      <p className="mt-4 text-sm leading-relaxed text-neutral-300 md:text-base">
        Apri WhatsApp, racconta a Mastro cosa stai facendo e inizia da lì.
      </p>
    </div>

    <div className="shrink-0">
      <button
        type="button"
        onClick={onOpen}
        data-testid="landing-cta-whatsapp-final"
        className="inline-flex items-center justify-center gap-2 rounded-xl bg-teal-500 px-7 py-4 text-base font-semibold text-neutral-950 transition-colors hover:bg-teal-400"
      >
        <MessageCircle className="h-5 w-5" />
        Prova Mastro su WhatsApp
      </button>
      <p className="mt-3 text-xs text-neutral-400 lg:text-right">
        La registrazione avviene dal link che ricevi in chat.
      </p>
    </div>
  </div>
);
